import { ContainerModule, WebuiIocKey } from '@ztechapps/webui.contract'
import { ProductResultCards } from './chat-result-renderers/ProductResultCards'
import { BlogResultList } from './chat-result-renderers/BlogResultList'
import { OrderCreatedMessage } from './chat-result-renderers/OrderCreatedMessage'
import { PurchaseOrderCreatedMessage } from './chat-result-renderers/PurchaseOrderCreatedMessage'
import { CreateProductProposals } from './chat-result-renderers/CreateProductProposals'
import { BuildPivotLayout } from './chat-result-renderers/BuildPivotLayout'

/**
 * No-op renderer bound to `WebuiIocKey.ai.chatRenderer.unknown` so tools
 * without a dedicated chat renderer resolve cleanly through
 * `useInjectComponent` instead of throwing "No binding found" on every
 * `ToolCallDisplay` mount (which floods the console with errors). The
 * caller filters this sentinel out of its per-tool lookup, so this stub
 * only mounts when `rendererKey` is undefined — at which point the
 * collapsible JSON fallback in `ToolCallDisplay` is what the user sees.
 */
const NoOpChatRenderer = () => null

/**
 * AI WebUI container module.
 *
 * Binds the shared AI chat tool result renderers so `ToolCallDisplay` can
 * look them up via `useInjectComponent(WebuiIocKey.ai.chatRenderer.*)` and
 * render rich cards/lists in place of the default JSON UI.
 *
 * Both admin and storefront load this same module — the per-surface URL
 * builders (`productUrl`, `blogUrl`, `orderUrl`, `purchaseOrderUrl`) flow
 * through `AiChatProvider` props, so the renderer components themselves do
 * not need per-app bindings.
 */
export const aiWebuiContainer = new ContainerModule((bind) => {
  bind(WebuiIocKey.ai.chatRenderer.searchProducts).to(ProductResultCards)
  bind(WebuiIocKey.ai.chatRenderer.searchBlogs).to(BlogResultList)
  bind(WebuiIocKey.ai.chatRenderer.createOrder).to(OrderCreatedMessage)
  bind(WebuiIocKey.ai.chatRenderer.createPurchaseOrder).to(PurchaseOrderCreatedMessage)
  bind(WebuiIocKey.ai.chatRenderer.createProduct).to(CreateProductProposals)
  bind(WebuiIocKey.ai.chatRenderer.buildPivotLayout).to(BuildPivotLayout)
  bind(WebuiIocKey.ai.chatRenderer.unknown).to(NoOpChatRenderer)
})
